import PageHeading from "component/ui/PageHeading";
import { Trash, Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonModal from "component/ui/CommonModal";
import { useDispatch, useSelector } from "react-redux";
import { deleteEvent, getPostingList } from "store/slice/booking";
import { getSportsIcon } from "helper/appConstant";
import { TYPES } from "helper/constant";
import FullPageLoader from "component/ui/fullPageLoader";
import requestIcon from "../../assets/request_match.png";
import AvatarStack from "component/ui/AvtarStack";
import Button from "component/ui/Button";
import SearchInput from "component/ui/SearchInput";
import { FiSearch } from "react-icons/fi";
import { FileText, User, ClipboardList, Calendar, MapPin } from "lucide-react";

const EventBox = React.memo(({ event, configData }) => {
  const users = [
    {
      image: "https://flowbite.com/docs/images/people/profile-picture-4.jpg",
      name: "User 1",
    },
    {
      image: "https://flowbite.com/docs/images/people/profile-picture-2.jpg",
      name: "User 2",
    },
    {
      image: "https://flowbite.com/docs/images/people/profile-picture-4.jpg",
      name: "User 3",
    },
  ];
  return (
    <div className="border border-gray-200 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden">
      {/* Header Section */}
      <div className="bg-gradient-to-r from-gray-100 to-gray-200 flex justify-between items-start p-3">
        <div className="flex gap-3 items-start flex-1">
          <div className="w-8 h-8 rounded-lg bg-green-500 p-1.5 shadow-sm flex-shrink-0">
            <img src={requestIcon} className="w-full h-full object-contain " />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-base font-medium text-gray-800 line-clamp-1">
              Join
            </p>
            <p className="text-xs border-b font-semibold border-highlight w-fit text-highlight cursor-pointer">
              View Details
            </p>
          </div>
        </div>
        <div className="p-2 bg-white rounded-md">
          <Trash2 size={18} className="text-red-700" />
        </div>
      </div>

      <div className="p-3">
        {/* Content Section */}
        <div className="flex items-start justify-between w-full ">
          <div className="flex flex-col gap-1 flex-1">
            {/* Document ID */}
            <div className="flex items-center gap-2 py-1">
              <FileText className="w-4 h-4 text-blue-500" />
              <p className="font-normal text-sm text-gray-800">
                PSZ1769002790850
              </p>
            </div>

            {/* Name */}
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <User className="w-4 h-4 text-black" />
              <span className="font-normal text-sm">Abhay Vishwakarma</span>
            </div>

            {/* Type / Title */}
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <ClipboardList className="w-4 h-4 text-orange-500" />
              <span className="font-normal text-sm">test</span>
            </div>

            {/* Date */}
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <Calendar className="w-4 h-4 text-blue-900" />
              <span className="font-normal text-sm">30/01/2026</span>
            </div>

            {/* Location */}
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <MapPin className="w-4 h-4 text-red-500" />
              <span className="font-normal text-sm ">Indore, Madhya Pradesh, India</span>
            </div>
          </div>

          {/* Category Badge */}
          <div className="flex items-center flex-col justify-center p-3 rounded-xl bg-gradient-to-br from-blue-100 to-blue-200 w-28 shadow-sm ml-3">
            <div className="w-10 h-10 flex justify-center rounded-lg bg-white p-2 shadow-sm mb-2">
              {getSportsIcon(configData?.gamesDetails, event?.sportName)}
            </div>
            <p className="text-xs font-semibold text-gray-700 text-center line-clamp-2 leading-tight">
              {event?.sportName}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});

const RequestSent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { postingListData } = useSelector((state) => state.booking);
  const { configData } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [searchQuery, setSearchQuery] = useState();

  useEffect(() => {
    setLoading(true);
    fetchPostingList();
  }, []);
  // fetch my posting list
  const fetchPostingList = (page, search) => {
    dispatch(getPostingList(page ?? 1, 12, search, setLoading));
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteSuccess = () => {
    setLoading(false);
    setIsModalOpen(false);
  };
  const handleConfirm = async () => {
    setLoading(true);
    const request = {
      language: "en",
      id: deleteData?.cardId,
      roomId: null,
      type:
        deleteData?.cardType == "event"
          ? TYPES?.EVENT_DELETE_TYPE
          : TYPES?.SERVICE_DELETE_TYPE,
    };
    dispatch(deleteEvent(request, handleDeleteSuccess));
  };

  return (
    <>
      <div className="min-h-screen p-4 md:p-6">
        <div className="container mx-auto">
          <div className="flex items-center justify-between">
            <PageHeading title="Requests Sent" />
          </div>
          {loading && <FullPageLoader />}
          <div className="rounded-2xl md:shadow-2xl md:bg-white border border-gray-100 overflow-hidden w-full md:p-5">
            <div className="w-1/2">
              <SearchInput
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search by card id/sport"
                icon={FiSearch}
                className="rounded-full"
              />
            </div>
            {postingListData?.data?.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
                {postingListData?.data?.map((event) => (
                  <EventBox
                    event={event}
                    configData={configData}
                    navigate={navigate}
                    setIsModalOpen={() => {
                      setIsModalOpen(true);
                      setDeleteData(event);
                    }}
                  />
                ))}
              </div>
            ) : (
              <div className="flex justify-center items-center h-40">
                No Posting Found
              </div>
            )}
          </div>
        </div>
      </div>

      <CommonModal
        isOpen={isModalOpen}
        title="Delete Item"
        message="Are you sure you want to delete this card?"
        confirmButtonText="Yes, Delete"
        cancleButtonText="Cancel"
        onConfirm={handleConfirm}
        onCancel={() => setIsModalOpen(false)}
        isFullPageLoading={loading}
        icon={<Trash />}
      />
    </>
  );
};

export default RequestSent;
